import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { Helmet as Helmet$1 } from "react-helmet-async";
import { useMantineTheme } from "@mantine/core";
import { useLanguage } from "../hooks/useLanguage.js";
const Helmet = ({ selfhostFonts }) => {
  const theme = useMantineTheme();
  const { language } = useLanguage();
  return /* @__PURE__ */ jsxs(Helmet$1, { htmlAttributes: { lang: language }, children: [
    !selfhostFonts && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("link", { href: "https://fonts.cdnfonts.com/css/fs-renaissance", rel: "preload", as: "style" }),
      /* @__PURE__ */ jsx("link", { href: "https://fonts.cdnfonts.com/css/fs-renaissance", rel: "stylesheet" }),
      /* @__PURE__ */ jsx("link", { rel: "preconnect", href: "https://fonts.googleapis.com" }),
      /* @__PURE__ */ jsx("link", { rel: "preconnect", href: "https://fonts.gstatic.com", crossOrigin: "anonymous" }),
      /* @__PURE__ */ jsx(
        "link",
        {
          href: "https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap",
          rel: "preload",
          as: "style"
        }
      ),
      /* @__PURE__ */ jsx(
        "link",
        {
          href: "https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap",
          rel: "stylesheet"
        }
      )
    ] }),
    /* @__PURE__ */ jsx("meta", { charSet: "utf-8" }),
    /* @__PURE__ */ jsx("meta", { name: "viewport", content: "minimum-scale=1, initial-scale=1, width=device-width" }),
    /* @__PURE__ */ jsx(
      "meta",
      {
        media: "all",
        name: "theme-color",
        content: theme.other.colorTokens.backgrounds.secondary
      }
    ),
    /* @__PURE__ */ jsx(
      "meta",
      {
        media: "(prefers-color-scheme: light)",
        name: "theme-color",
        content: theme.other.colorTokens.backgrounds.secondary
      }
    ),
    /* @__PURE__ */ jsx(
      "meta",
      {
        media: "(prefers-color-scheme: dark)",
        name: "theme-color",
        content: theme.other.colorTokens.backgrounds.secondary
      }
    )
  ] });
};
export {
  Helmet as default
};
